import { LocationDescriptorObject } from 'history';

import AppConstants from 'constants/AppConstants';

export function push(location: LocationDescriptorObject) {
  return {
    type: AppConstants.HISTORY_LOCATION_PUSH,
    payload: location,
  };
}

export function replace(location: LocationDescriptorObject) {
  return {
    type: AppConstants.HISTORY_LOCATION_REPLACE,
    payload: location,
  };
}

export function back(n: number) {
  return {
    type: AppConstants.HISTORY_LOCATION_BACK,
    payload: n,
  };
}
